import Seo from "@/components/Seo";
import Reveal from "@/components/Reveal";

function H2({ children }) {
  return (
    <h2 className="mt-10 font-display text-xl font-bold text-ink">{children}</h2>
  );
}

export default function Privacy() {
  return (
    <>
      <Seo
        title="Privacy Policy | Web Pilot"
        description="How Web Pilot collects, uses, and protects the information you share — form submissions, analytics, cookies, and messaging consent. Effective October 2026."
      />

      <section className="bg-navy py-16 sm:py-20">
        <div className="mx-auto max-w-6xl px-4 sm:px-6">
          <Reveal>
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-skyblue">
              Legal
            </p>
            <h1 className="mt-3 font-display text-3xl font-extrabold tracking-tight text-white sm:text-4xl">
              Privacy Policy
            </h1>
            <p className="mt-4 text-slate-300">Effective date: October 2026</p>
          </Reveal>
        </div>
      </section>

      <section className="bg-white py-16 sm:py-20">
        <div className="mx-auto max-w-3xl px-4 text-slate-600 sm:px-6">
          <H2>What we collect</H2>
          <p className="mt-3 leading-relaxed">
            When you fill out a form on this site, we collect the information you
            give us: your name, business name, trade, phone number, email
            address, current website, city or service area, what you want help
            with, and any message you include. We also note whether you consented
            to receive text messages.
          </p>
          <p className="mt-3 leading-relaxed">
            Like most websites, we use basic analytics and cookies to understand
            how visitors use the site — pages viewed, approximate location, and
            device type.
          </p>

          <H2>How we use it</H2>
          <p className="mt-3 leading-relaxed">
            We use your information to respond to your inquiry, deliver the
            services you ask for, and send the messages you've consented to —
            such as follow-ups and appointment reminders. Nothing else.
          </p>

          <H2>Text messages</H2>
          <div
            data-testid="privacy-sms-line"
            className="mt-3 rounded-lg border-l-4 border-skyblue bg-skyblue-soft p-4 font-medium leading-relaxed text-navy"
          >
            No mobile information will be shared with third parties or affiliates
            for marketing or promotional purposes. Text messaging originator
            opt-in data and consent will not be shared with any third parties.
          </div>

          <H2>We never sell your information</H2>
          <p className="mt-3 leading-relaxed">
            We do not sell your personal information. We don't rent it, trade it,
            or hand it to advertisers.
          </p>

          <H2>Service providers</H2>
          <p className="mt-3 leading-relaxed">
            We use a small number of service providers to run Web Pilot: a
            hosting provider for this website, and a CRM and messaging platform
            to manage inquiries and send the messages you've consented to. These
            providers process information only on our instructions.
          </p>

          <H2>Data retention</H2>
          <p className="mt-3 leading-relaxed">
            We keep form submissions and messages for as long as needed to
            respond to your inquiry and provide services. After that, we delete
            them.
          </p>

          <H2>Your rights</H2>
          <p className="mt-3 leading-relaxed">
            You can ask to see, correct, or delete the personal information we
            hold about you. Email{" "}
            <a
              href="mailto:zach@webpilot.agency"
              data-testid="privacy-email-link"
              className="text-skyblue underline"
            >
              zach@webpilot.agency
            </a>{" "}
            and we'll take care of it.
          </p>

          <H2>Contact</H2>
          <p className="mt-3 leading-relaxed">
            Questions about this policy? Email{" "}
            <a
              href="mailto:zach@webpilot.agency"
              className="text-skyblue underline"
            >
              zach@webpilot.agency
            </a>
            . Web Pilot is operated by Zachary Laboyteaux and serves the
            Indianapolis, Indiana area.
          </p>
        </div>
      </section>
    </>
  );
}
